export const img_300 = "https://image.tmdb.org/t/p/w300";
export const img_500 = "https://image.tmdb.org/t/p/w500";




  export const REACT_APP_KEY = "56c9ead0623b559aefdf59cefb9899e8";

  export const noPicture =
  "https://upload.wikimedia.org/wikipedia/en/6/60/No_Picture.jpg";
  
  export const unavailable =
    "https://www.movienewz.com/img/films/poster-holder.jpg";
  
    export const unavailableLandscape =
    "https://user-images.githubusercontent.com/10515204/56117400-9a911800-5f85-11e9-878b-3f998609a6c8.jpg";
  
  
   //Video - 
    //`https://api.themoviedb.org/3/${media_type}/${id}/videos?api_key=${REACT_APP_API_KEY}&language=en-US`
    
   //modal = `https://api.themoviedb.org/3/${media_type}/${id}?api_key=${REACT_APP_API_KEY}&language=en-US`
  
    //tv ='https://api.themoviedb.org/3/genre/tv/list?language=en
  
   //movie='https://api.themoviedb.org/3/discover/movie?api_key='
  
   //trending =`https://api.themoviedb.org/3/trending/all/day?api_key=
   //series = https://api.themoviedb.org/3/discover/tv?api_key=${REACT_APP_KEY}&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=
          //${page}&with_genres=${genreURL}
  
   // videos = 'https://api.themoviedb.org/3/movie/movie_id/videos?language=en-US'

   //Search - 
//https://api.themoviedb.org/3/search/${type?"tv":"movie"}?api_key=${process.env.REACT_APP_API_KEY }&language=en-US&query=
//${searchText}&page=${page}&include_adult=false`